export default __webpack_public_path__ + "static/media/mw.cec19039.svg";